module.exports = __webpack_public_path__ + "static/Q4Answer3_Considerate_GiangVu-3c338bd5ed196145fa8cced08596e314.jpg";